let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lLK0D")).then(() => parcelRequire('hpDFj'));